export const SHORT_COMPANY_ID_LENGTH = 8;

/** First 8 letters/numbers from a company UUID (hyphens stripped). */
export function formatShortCompanyId(companyId: string | null | undefined): string {
  if (!companyId) return '';
  return String(companyId)
    .replace(/[^a-zA-Z0-9]/g, '')
    .slice(0, SHORT_COMPANY_ID_LENGTH)
    .toLowerCase();
}
